import { FC } from 'react';
import { Box, Fade, Paper, Typography } from '@mui/material';
import HelpAccordion, { HelpAccordionContent } from '@acorn-portal/shared/src/components/accordion/HelpAccordion';
import PageTitle from '@acorn-portal/shared/src/components/text/PageTitle';
import { DEFAULT_CLAIMS_SITE, PHONE_NUMBERS } from '@acorn-portal/shared/src/utils/constants';

const content: HelpAccordionContent[] = [
	{
		title: 'Claims',
		content: (
			<div>
				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					In the unlikely and unfortunate event of an accident of any kind, regardless of who you think is responsible
					or to blame, you need to report it to us within 24 hours
				</Typography>

				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					To report an accident or incident to us, please call our claims notification line which is open 24 hours a
					day, 7 days a week for your utmost convenience.
				</Typography>

				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					Click here to report an accident to{' '}
					<a href={DEFAULT_CLAIMS_SITE} target='_blank' rel='noreferrer'>
						Acorn Claims
					</a>
				</Typography>

				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					Acorn Insurance Claim Line:{' '}
					<a href={`tel:${PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER}`}>{PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER}</a>
				</Typography>
			</div>
		),
	},
	{
		title: 'Making Changes',
		content: (
			<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
				The quickest way to make a change on your policy is by clicking Make a Change on the Policy screen of this
				portal. If you are having issues making a change, or wish to discuss your change, please contact us using the
				webchat facility on our{' '}
				<a href='https://acorninsure.co.uk/' target='_blank' rel='noreferrer'>
					main website
				</a>
			</Typography>
		),
	},
	{
		title: 'Cancellations',
		content: (
			<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
				You can cancel your policy at any time you choose. If you wish to do so, please{' '}
				<a href='https://www.acorninsure.co.uk/policy-cancellation/' target='_blank' rel='noreferrer'>
					click here
				</a>
			</Typography>
		),
	},
	{
		title: 'Payments',
		content: (
			<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
				Missed a Payment? Manage your payments within this portal from the relevant policy under the payments tab
			</Typography>
		),
	},
	{
		title: 'Upload documents',
		content: (
			<div>
				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					Need to send us your Driving Licence details? Please use the following{' '}
					<a
						href='https://www.acorninsure.co.uk/documents/upload-driving-licence-details/'
						target='_blank'
						rel='noreferrer'
					>
						link
					</a>
				</Typography>
				<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
					Need to submit your proof of No Claims Discount? Please use the following{' '}
					<a
						href='https://www.acorninsure.co.uk/documents/make-a-change-to-your-policy/document-upload/'
						target='_blank'
						rel='noreferrer'
					>
						link
					</a>
				</Typography>
			</div>
		),
	},
	{
		title: 'No Claims Discount',
		content: (
			<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
				We will email this to you upon request or at the end of your policy term. If you don&apos;t receive notification
				of your No Claims Discount in a few days, please contact us using the online chat facility by clicking the robot
				icon in the bottom right of your screen
			</Typography>
		),
	},
	{
		title: 'New Policy',
		content: (
			<Typography variant='body1' component='p' sx={{ margin: '1rem' }}>
				If you wish to obtain a new policy, or get a new quote, please{' '}
				<a href='https://pc-quote.acorninsure.co.uk/' target='_blank' rel='noreferrer'>
					click here
				</a>
			</Typography>
		),
	},
];

const NeedHelp: FC = () => {
	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box
					sx={(theme) => ({
						[theme.breakpoints.down('md')]: { margin: '0.5rem' },
						margin: '2rem',
					})}
				>
					<PageTitle>Need help?</PageTitle>
					<Typography variant='body1' component='p' sx={{ padding: '1rem' }}>
						Please find some of the frequently asked questions below.
					</Typography>
					<HelpAccordion content={content} />
					<Typography
						variant='body1'
						component='p'
						sx={(theme) => ({
							padding: '1rem',
							'& ul': { listStyle: 'none' },
							'& b': { color: theme.palette.primary.main },
						})}
					>
						If you still require help, please contact us using the webchat facility on our{' '}
						<a href='https://acorninsure.co.uk/' target='_blank' rel='noreferrer'>
							main website
						</a>
						, which is the quickest and easiest way to contact us
						<ul>
							<li>
								<b>Opening Hours</b>
							</li>
							<li>
								<b>Monday- Friday</b>: 08:30 to 18:00
							</li>
							<li>
								<b>Saturday:</b> 09:00 to 17:00
							</li>
							<li>
								<b>Sunday:</b> Closed
							</li>
						</ul>
					</Typography>
				</Box>
			</Fade>
		</Paper>
	);
};

export default NeedHelp;
